export default __webpack_public_path__ + "static/media/pattern2.7f815950.svg";